
import React, { Fragment, ReactElement, useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import API from '@sesame/web-api';

import Alert, { AlertTypes } from 'src/components/AlertDisplay';
import ModalDialog from 'src/components/ModalDialog';
import { FormInput } from 'src/components/Form';
import { ILoadState, IComponent, IRack, IArenaPart } from 'src/types';
import { PartInput } from './PartInput';

type IFormData = {
  bomPartNumber: string,
  revision: string,
  arenaGuid: string,
  quantity: string,
} & { [key: string]: string };

type fieldNames = keyof IFormData;

interface IAddLooseNodeProps {
  salesorderId: number;
  rackId: number;
  onSave?: () => void;
}

export const AddLooseNode = ({ salesorderId, rackId, onSave }: IAddLooseNodeProps) => {
  const  {isLoading, isAuthenticated, getAccessTokenSilently } = useAuth0();

  const [formData, setFormData] = useState<IFormData>({
    bomPartNumber: '',
    revision: '',
    arenaGuid: '',
    quantity: "1",
  });

  const [arenaPart, setArenaPart] = useState<IArenaPart>();
  const [validation, setValidation] = useState<fieldNames[]>([]);
  const [partDisplayState, setPartDisplayState] = useState<ILoadState>(ILoadState.NEW);

  const formChange = (item: fieldNames, event: React.FormEvent<HTMLInputElement | HTMLSelectElement>) => {
    const newFormData = { ...formData };
    newFormData[item] = event.currentTarget.value;

    setFormData(newFormData);
  }


  const validate = () => {
    const errors: fieldNames[] = [];

    if (formData.bomPartNumber == '') {
      errors.push('bomPartNumber');
    }
    setValidation([...errors]);
    return errors.length;
  }

  const save = (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault();

    if (validate() > 0) {
      return;
    }

    getAccessTokenSilently().then( accessToken => {

    new Promise(function(resolve, reject) {

      resolve(rackId ? { rackId } : API.post(accessToken, `api/v1/rack?noderack=true`,
        {
          rackId: 0,
          salesorderId: salesorderId,
          bomPartNumber: 'Loose Nodes',
          revision: 'A',
          arenaGuid: '-',
          identifier: 'Loose Nodes',
          description: 'Loose Nodes',
        }
      ).then(resp => resp.data));
    })
      .then(nodeRackId => {

        const nri = nodeRackId as { rackId: number };
        console.log('Saving loose node to rack ' + nri.rackId);
        const newNode: IComponent = {
          rackId: nri.rackId as number,
          componentId: 0,
          salesorderId: salesorderId,
          partNumber: formData.bomPartNumber,
          revision: formData.revision,
          arenaGuid: formData.arenaGuid,
          description: 'sample',
          name: '',
          type: '',
          portCount: 0,
          serialNumber: '',
          portmap: [],
        }

        API.post(accessToken, `/api/v1/component?bom=true&quantity=${formData.quantity}`, newNode, { timeout: 6000 })
          .then((res) => {
            Alert(AlertTypes.SUCCESS, "Node Saved");
            if (onSave) {
              onSave();
            }
            const el = document.getElementById('newnodes');
            if (el) {
              el.click()
            }
          })
          .catch((err) => {
            Alert(AlertTypes.ERROR, "Error saving part: " + err.message);
          });
      })
      .catch((err) => {
        Alert(AlertTypes.ERROR, "Error creating node container: " + err.message);
      });
    });
  }


  return <ModalDialog
    id="newnodes"
    title={`Add Loose Node - Sales Order ${salesorderId}`}
    buttonText="Add Loose Node">
    <form>
      <PartInput
        partNumber={formData.bomPartNumber}
        partFilter='Component'
        onChange={(p, r) => {
          const fd = formData;
          fd.bomPartNumber = p.number;
          fd.revision = r.number;
          fd.arenaGuid = r.guid;
          setFormData(fd);
        }}
      />
      <FormInput
        label="Quanity"
        name="quantity"
        changeFn={formChange}
        data={formData}
        validation={validation}
      />
      <p className="uk-text-right">
        <button
          className="uk-button uk-button-primary uk-button-small"
          onClick={(e) => save(e)}>
          Save
          </button>
      </p>

    </form>
  </ModalDialog>
}
